import { Component, OnInit } from '@angular/core';
import { HomeDesignService, HomeDesign } from '../../services/home-design.service';
import { AwscontrolService } from 'app/services/aws/awscontrol.service';


@Component({
  selector: 'app-home-design',
  templateUrl: './home-design.component.html',
  styleUrls: ['./home-design.component.scss']
})
export class HomeDesignComponent implements OnInit {

  imageList: string[] = [];
  loading: boolean = false;
  isAdmin: boolean = false;
  errorMessage: string = '';

  // Upload
  selectedFiles: FileList | null = null;
  uploadLoading: boolean = false;

  // Edit mode
  editMode: { [index: number]: boolean } = {};
  editUrl: { [index: number]: string } = {};

  constructor(
    private homeDesignService: HomeDesignService,
    private awsService: AwscontrolService
  ) { }

  ngOnInit(): void {
    this.checkAdminRole();
    this.loadDesign();
  }

  checkAdminRole(): void {
    try {
      const authUser = sessionStorage.getItem('auth-user');
      if (authUser) {
        const userObj = JSON.parse(authUser);
        const roles = userObj.roles || userObj.role || [];
        this.isAdmin = Array.isArray(roles)
          ? roles.some((r: any) => r === 'admin' || r.authority === 'admin')
          : roles === 'admin';
      }
    } catch (e) {
      this.isAdmin = false;
    }
  }

  loadDesign(): void {
    this.loading = true;
    this.errorMessage = '';
    this.homeDesignService.getHomeDesign().subscribe({
      next: (data: HomeDesign) => {
        this.imageList = data.imageList || [];
        this.imageList.forEach((url, index) => {
          this.editUrl[index] = url;
          this.editMode[index] = false;
        });
        this.loading = false;
      },
      error: (err) => {
        this.errorMessage = 'Impossible de charger la page d\'accueil.';
        this.loading = false;
        console.error(err);
      }
    });
  }

  // ---------- File selection ----------
  onFileSelected(event: any): void {
    this.selectedFiles = event.target.files;
  }

  // Trigger hidden file input
  triggerFileInput(): void {
    document.getElementById('fileInput')?.click();
  }

  // ---------- Upload to AWS + save ----------
  uploadImages(): void {
    if (!this.selectedFiles || this.selectedFiles.length === 0) {
      this.errorMessage = 'Veuillez sélectionner au moins une image.';
      return;
    }
    const files = Array.from(this.selectedFiles);
    this.uploadLoading = true;
    this.errorMessage = '';
    this.awsService.uploadFiles(files, 'home-design').subscribe({
      next: (response) => {
        this.uploadLoading = false;
        if (response.success && response.urls && response.urls.length > 0) {
          this.imageList.push(...response.urls);
          this.saveChanges();
          this.selectedFiles = null;
          // Reset file input
          const input = document.getElementById('fileInput') as HTMLInputElement;
          if (input) input.value = '';
        } else {
          this.errorMessage = 'Échec de l\'upload: ' + (response.error || '');
        }
      },
      error: (err) => {
        this.uploadLoading = false;
        this.errorMessage = 'Erreur lors de l\'upload des fichiers.';
        console.error(err);
      }
    });
  }

  // ---------- Edit image URL (inline) ----------
  enableEdit(index: number): void {
    this.editMode[index] = true;
    this.editUrl[index] = this.imageList[index];
  }

  saveEdit(index: number): void {
    if (!this.editUrl[index]?.trim()) return;
    this.imageList[index] = this.editUrl[index].trim();
    this.editMode[index] = false;
    this.saveChanges();
  }

  cancelEdit(index: number): void {
    this.editMode[index] = false;
  }

  // ---------- Delete image (remove from S3 then save) ----------
  deleteImage(index: number): void {
    if (!confirm('Supprimer cette image définitivement ?')) return;
    const urlToDelete = this.imageList[index];
    this.imageList.splice(index, 1);
    delete this.editMode[index];
    delete this.editUrl[index];

    if (urlToDelete && urlToDelete.includes('amazonaws.com')) {
      this.awsService.deleteFile(urlToDelete).subscribe({
        next: () => this.saveChanges(),
        error: (err) => {
          console.error('Erreur suppression S3:', err);
          this.errorMessage = 'Image supprimée localement, mais échec de la suppression sur AWS.';
          this.saveChanges();
        }
      });
    } else {
      this.saveChanges();
    }
  }

  // ---------- Save to backend ----------
  saveChanges(): void {
    this.loading = true;
    this.errorMessage = '';
    this.homeDesignService.updateHomeDesign(this.imageList).subscribe({
      next: () => this.loading = false,
      error: (err) => {
        this.errorMessage = 'Erreur lors de la sauvegarde.';
        this.loading = false;
        console.error(err);
        this.loadDesign(); // revert
      }
    });
  }
}